import * as React from "react";

interface PageProps {
    children: readonly React.ReactNode[];
}

export function Page(props: PageProps): JSX.Element {
    return <>{props.children}</>;
}
